import React, { useState, useEffect } from 'react';
import image from "../assets/images/mes_page.png";
import {Link} from "react-router";
import image1 from "../assets/images/mas1.png";
import image2 from "../assets/images/mas2.png";
import image3 from "../assets/images/mas3.png";
import barbie1 from "../assets/images/barbie1.png";
import barbie2 from "../assets/images/barbie2.png";


const Mesotherapy = () => {
    const barbieImages = [barbie1, barbie2];
    const [barbieIndex, setBarbieIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setBarbieIndex((prev) => (prev + 1) % barbieImages.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
            <div className={'w-full relative'}>
                <img src={image} alt="" className={'w-full pt-20'}/>
                <div className={'absolute top-0 left-0 w-full h-full bg-black opacity-[17%]'}></div>
                <p className={'absolute md:bottom-16 left-[8%] text-4xl text-white bottom-1 '}>Mesotherapy Cocktails</p>
                <Link to={'/'}>
                    <div className={'absolute top-24 left-10 '}>
                        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.2 29.1199L17.68 22.5999C16.91 21.8299 16.91 20.5699 17.68 19.7999L24.2 13.2799"
                                  stroke="#fff" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                  stroke-linejoin="round"/>
                        </svg>

                    </div>
                </Link>
            </div>


            <section className="max-w-4xl mx-auto py-12 text-center p-5">
                <h2 className="text-2xl md:text-3xl font-medium mb-6">
                    Exclusive treatment cocktails dedicated to the needs of skins requiring intensive revitalization and
                    reconstruction
                </h2>
                <p className="text-gray-700 text-lg leading-relaxed mx-auto">
                    The product formulas are based on a rich complex of active ingredients, guaranteeing holistic
                    effects and multi-level skin rejuvenation. Synergic combination of hyaluronic acid, amino acids,
                    minerals, vitamins, coenzymes, and antioxidants provides deep skin supplementation and quick effects
                    of smoothing, tightening, and moisturizing the skin. A wide range of products with different
                    concentrations and component combinations allows to adjust the therapy to individual skin needs.
                </p>
            </section>


            <div className="bg-white py-12 px-6 md:px-12">
                {/* Whitening CCAG1200 Section */}
                <section className="max-w-7xl mx-auto mb-16">
                    <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-6">1. WHITENING CCAG1200</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                        {/* Left Content */}
                        <div>
                            <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
                                ADVANCE FORMULA DESIGNED FOR SKIN DEPIGMENTATION AND WHITENING. A depigmenting
                                concentrate designed for intensive treatments to reduce discoloration. Amazing formula
                                with magnesium ascorbic phosphate, alpha arbutin, coumarin and glutathione and many
                                minerals and peptides for maximize skin rejuvenation and gives it a bright, radiant
                                look.
                            </p>
                            <h3 className="text-xl font-bold text-gray-900 mb-4">WHITENING CCAG1200 IS RECOMMENDED:</h3>
                            <ul className="list-disc list-inside text-gray-700 text-lg md:text-xl space-y-2 mb-6">
                                <li>Skin depigmentation and whitening</li>
                                <li>Discoloration and post-inflammatory</li>
                                <li>Healthy glow restoration</li>
                            </ul>
                            <ul className="list-disc list-inside text-gray-700 text-lg md:text-xl space-y-2">
                                <li><strong>Whitening cocktail:</strong> Magnesium ascorbic phosphate, Coumarin,
                                    Glutathione, Arbutin
                                </li>
                                <li><strong>Peptide complex:</strong> Octapeptide-2, heptapeptide-6, and Oligopeptide-34
                                </li>
                                <li><strong>Mineral:</strong> Potassium Chloride, Magnesium Sulfate, Sodium Acetate</li>
                            </ul>
                        </div>
                        {/* Right Content */}
                        <div className="w-3/4 mx-auto overflow-hidden rounded-lg shadow-md order-first md:order-last">
                            <img
                                src={image1}
                                alt="Whitening CCAG1200"
                                className="w-full h-full object-[center_30%]"
                            />
                        </div>
                    </div>
                </section>
            </div>


            <section className="max-w-screen-2xl p-5 mx-auto mb-16">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    {/* Left Content - Image Slider */}
                    <div className="relative w-3/4 mx-auto aspect-square overflow-hidden rounded-lg shadow-md">
                        {barbieImages.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                alt={`Barbie Rejuvenation ${index + 1}`}
                                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${index === barbieIndex ? 'opacity-100' : 'opacity-0'}`}
                            />
                        ))}
                    </div>
                    {/* Right Content */}
                    <div>
                        <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-6">2. BARBIE
                            REJUVENATION</h2>

                        <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
                            Multi-ingredient rejuvenating formula dedicated for tired skin. This meso cocktail
                            enriched with hyaluronic acid is designed to quickly improve skin hydration and
                            firmness, as well as to eliminate the first wrinkles and signs of ageing.
                        </p>
                        <p className="text-gray-700 text-lg md:text-xl leading-relaxed">
                            <strong>Barbie</strong> rejuvenation is composed of <strong>hyaluronic acid</strong> and
                            a rejuvenating complex to dehydrated skin and lack of skin density and radiance. Barbie
                            rejuvenation <strong>helps</strong> to delay the appearance of wrinkles and increases
                            hydration, glow, and radiance.
                        </p>
                    </div>
                </div>
            </section>


            <section className="max-w-7xl mx-auto mb-16 p-5">


                <div className={'max-w-4xl'}>

                    <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
                        Amino acids and trace elements activate the regeneration of tissues and restore the
                        epidermal barrier. Vitamins provide antioxidant activity and protection of the skin. The
                        skin will be refreshed, have a rested appearance, and begin to radiate health from the
                        inside.
                    </p>
                    <ul className="list-disc list-inside text-gray-700 text-lg md:text-xl space-y-2">
                        <li><strong>SODIUM HYALURONATE</strong></li>
                        <li><strong>REJUVENATION COMPLEX:</strong> <br/> Resorcinol, tranexamic acid, niacinamide</li>
                        <li><strong>PEPTIDES:</strong> <br/> Hexapeptide-8 and octapeptide-3</li>
                    </ul>

                </div>
            </section>


            <section className="max-w-7xl mx-auto mb-16 p-5">
                <h2 className="text-2xl md:text-3xl font-bold text-[#0E5287] mb-6">3. AMBER PLUS</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                    {/* Left Content */}
                    <div>
                        <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
                            Amber plus is a concentrated and most powerful stimulant in skin redermalization and
                            anti-aging prevention. Redermalization is the most effective method of stimulating the skin,
                            involving its full restoration and reconstruction.
                        </p>
                        <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
                            <strong>A Three-dimensional antiaging effect</strong> by increasing tissue hydration,
                            stimulation of collagen and integral skin proteins, as well as antioxidant protection of
                            cells.
                        </p>
                        <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-6">
                            <strong>The effect is enhanced</strong> by the use of the highest concentrations of succinic
                            acid and high molecular weight hyaluronic acid. <strong>Amber+</strong> is a combination of
                            action on all causes of skin aging, which ensures the fastest rejuvenation effects.
                        </p>
                        <ul className="list-disc list-inside text-gray-700 text-lg md:text-xl space-y-2">
                            <li><strong>HYALURONIC ACID MMW:</strong> 10mg/1ml</li>
                            <li><strong>HYALURONIC ACID LMW:</strong> 20mg/1ml</li>
                            <li><strong>SUCCINIC ACID:</strong> 20mg/1ml</li>
                        </ul>
                    </div>
                    {/* Right Content */}
                    <div>
                        <img
                            src={image3}
                            alt="Amber Plus"
                            className="rounded-lg  w-3/4 mx-auto"
                        />
                    </div>
                </div>
            </section>

        </div>
    );
};

export default Mesotherapy;